import { baseApi, sendIDArray } from './base.service';

type FormName = {
  id: string;
  name: string;
}

type FormNameResponse = {
  forms: FormName[];
}

type PublishAttrs = {
  formId: string;
  setShow: (show: boolean) => void;
  setError: (error: string) => void;
}

type FormNameHash = Record<FormName['id'], FormName['name']>

const formsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFormNames: build.query<FormNameHash, string[]>({
      query: (ids) => `/api/v2/forms?basic_info=true&${sendIDArray(ids)}`,
      transformResponse: (response: FormNameResponse) => response.forms.reduce((acc, form) => {
        acc[form.id] = form.name;
        return acc;
      }, {}),
    }),
    getForm: build.query<any, string>({
      query: (id) => `/api/v2/forms/${id}`,
      transformResponse: (response: any) => response.form,
    }),
    createForm: build.mutation<any, any>({
      query: (form) => ({
        url: '/api/v2/forms',
        method: 'POST',
        body: { ...form },
      }),
    }),
    publishForm: build.mutation<PublishAttrs, any>({
      query: ({ formId }) => ({
        url: `/api/v2/forms/${formId}/publish`,
        method: 'POST',
      }),
      async onQueryStarted({ setShow, setError }, { queryFulfilled }) {
        await queryFulfilled
          .then(() => {
            setShow(false);
            window.location.reload();
          })
          .catch((error) => {
            console.error('Error publishing form:', error);
            setError('There was a problem publishing the test version. Please try again.');
          });
      },
    }),
  }),
});

export const {
  useGetFormNamesQuery,
  useGetFormQuery,
  useCreateFormMutation,
  usePublishFormMutation,
} = formsApi;

export default formsApi;
